import { Col, Form, Input, Row, Select } from 'antd'
import React, { useState } from 'react'
import PropTypes from 'prop-types'

import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import BackIcon from '@material-ui/icons/ArrowBack'
import { withSnackbar } from 'notistack'
import { withContext } from '../../context'

import { styles } from './styles'
import { isMobile } from '../../utils'
import Logo from '../../components/Logo'
import { provinces } from '../../config/provinces.json'
import TitleBin from '../../components/TitleBin'
import { isNumeric } from '../../utils/number'
import axios from 'axios'
import { ButtonEx, CardContentEx } from '../../shared.style'
import AddLocation from './AddLocation'
import AddMaterial from './AddMaterial'
import { ENDPOINT } from '../../utils/constants'
import { useDeepEffect } from '../../utils/hooks'
import { CardMaterialEx } from '../../material.style'
import MainStep4 from '../../components/MainStep4'

export const Signup = ({ history, enqueueSnackbar, match }) => {
  const { heroType } = match.params

  const [form] = Form.useForm()
  const [page, setPage] = useState('1')
  const [formData, setFormData] = useState({})
  const [products, setProducts] = useState([])

  async function fetchData() {
    const res = await axios.get(ENDPOINT + `/product/groupByCategory`)
    setProducts(res.data)
  }

  useDeepEffect(() => {
    fetchData()
  }, [])

  function onBack(e) {
    e.preventDefault()
    switch (page) {
      case '3':
        setPage('2')
        break
      case '2':
        setPage('1')
        break
      default:
        return null
    }
  }

  const onFinish = async (values) => {
    const data = {
      email: values.email || `${values.tel}@green2get.com`,
      name: values.name,
      password: values.password,
      tel: values.tel,
      lineId: values.lineId,
      province: values.province,
      plateLicense: values.plateLicense || '',
      purpose: values.purpose || '',
      postalAddress: values.postalAddress || ''
    }

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_ENDPOINT}/hero/existing`,
        {
          email: data.email,
          name: data.name,
          tel: data.tel
        }
      )

      if (!res.data.isExist) {
        await setFormData(data)
        await setPage('2')
      } else {
        enqueueSnackbar(res.data.message)
      }
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <main style={styles.main}>
      <AppBar position="sticky">
        <Toolbar style={styles.toolbar}>
          {page !== '1' && page !== '4' ? (
            <IconButton
              id="btnBack"
              color="inherit"
              aria-label="Menu"
              onClick={(e) => onBack(e)}>
              <BackIcon />
            </IconButton>
          ) : (
            <IconButton
              id="btnBack"
              color="inherit"
              aria-label="Menu"
              onClick={() => history.goBack()}>
              <BackIcon />
            </IconButton>
          )}
          <Logo />
          <IconButton style={{ width: '48px' }} />
        </Toolbar>
      </AppBar>
      {page !== '4' && (
        <Row type="flex" gutter={16}>
          <Col>
            <TitleBin name="ข้อมูลทั่วไป" no={'1'} page={page} />
          </Col>
          {heroType !== 'POSTAL' && (
            <Col>
              <TitleBin name="สถานที่รับซื้อ" no={'2'} page={page} />
            </Col>
          )}
          {heroType !== 'FACTORY' && (
            <Col>
              <TitleBin
                name="วัสดุที่รับซื้อ"
                no={heroType !== 'POSTAL' ? '3' : '2'}
                page={page}
              />
            </Col>
          )}
        </Row>
      )}
      {page !== '4' ? (
        <CardMaterialEx width={1000} elevation={isMobile ? 0 : 1} square>
          <CardContentEx>
            {page === '1' && (
              <Form form={form} onFinish={onFinish} layout="vertical">
                <Form.Item
                  name="tel"
                  label="เบอร์โทรศัพท์ (Telephone)"
                  rules={[
                    {
                      required: true,
                      message: 'กรอกเบอร์โทรศัพท์'
                    },
                    {
                      min: 9,
                      message: 'กรอกอย่างน้อย 9 - 10 ตัวเลข'
                    }
                  ]}>
                  <Input maxLength={10} onKeyPress={isNumeric} />
                </Form.Item>
                <Form.Item
                  name="email"
                  label="อีเมล (Email)"
                  rules={[
                    {
                      type: 'email',
                      message:
                        'ไม่สามารถกรอกภาษาไทยและใส่รูปแบบของอีเมลให้ถูกต้อง'
                    }
                  ]}>
                  <Input />
                </Form.Item>
                <Form.Item
                  name="password"
                  label="รหัสผ่าน (Password)"
                  rules={[
                    {
                      required: true,
                      message: 'กรอกรหัสผ่าน'
                    },
                    {
                      min: 6,
                      message: 'ต้องกรอกอย่างน้อย 6 ตัวอักษร'
                    },
                    {
                      pattern: /^[a-zA-Z0-9\b!@#$%^&_.]+$/,
                      message: 'กรอกภาษาอังกฤษ ตัวเลข หรือ สัญลักษณ์ เท่านั้น'
                    }
                  ]}>
                  <Input.Password />
                </Form.Item>
                <Form.Item
                  name="confirm"
                  label="ยืนยันรหัสผ่าน (Confirm Password)"
                  dependencies={['password']}
                  rules={[
                    {
                      required: true,
                      message: 'กรอกยืนยันรหัสผ่าน'
                    },
                    {
                      pattern: /^[a-zA-Z0-9\b!@#$%^&_.]+$/
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('password') === value) {
                          return Promise.resolve()
                        }
                        return Promise.reject(new Error('รหัสผ่านไม่ตรงกัน'))
                      }
                    })
                  ]}>
                  <Input.Password />
                </Form.Item>
                <Form.Item
                  name="name"
                  label="ชื่อฮีโร่/ชื่อร้าน (Hero's name)"
                  rules={[
                    {
                      required: true,
                      message: 'กรอกชื่อฮีโร่'
                    }
                  ]}>
                  <Input placeholder="เช่นฮีโร่/ชื่อร้านซึ่งจะแสดงในแอพพลิเคชั่น Green2Get" />
                </Form.Item>
                {heroType === 'SCOOTER' && (
                  <Form.Item
                    name="plateLicense"
                    label="เลขทะเบียนรถ (License Plate)"
                    rules={[
                      {
                        required: true,
                        message: 'กรอกเลขทะเบียนรถ'
                      }
                    ]}>
                    <Input />
                  </Form.Item>
                )}
                {(heroType === 'DROP_POINT' || heroType === 'POSTAL') && (
                  <Form.Item
                    name="purpose"
                    label="การรับขยะไปแล้วทำอย่างไรต่อ (Purpose of Receiving)"
                    rules={[
                      {
                        required: true,
                        message: 'กรอกการรับขยะ'
                      }
                    ]}>
                    <Input />
                  </Form.Item>
                )}
                {heroType === 'POSTAL' && (
                  <Form.Item
                    name="postalAddress"
                    label="ที่อยู่ไปรษณีย์ในการรับขยะ (Portal Address)"
                    rules={[
                      {
                        required: true,
                        message: 'กรอกที่อยู่ไปรษณีย์'
                      }
                    ]}>
                    <Input />
                  </Form.Item>
                )}
                <Form.Item
                  name="province"
                  label="จังหวัด (Province)"
                  initialValue={provinces[0].name_th}
                  rules={[
                    {
                      required: true,
                      message: 'เลือกจังหวัด'
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (
                          !value ||
                          getFieldValue('province') !== '-- เลือกจังหวัด --'
                        ) {
                          return Promise.resolve()
                        }

                        return Promise.reject(new Error('เลือกจังหวัด'))
                      }
                    })
                  ]}>
                  <Select>
                    {provinces.map((option, index) => (
                      <Select.Option value={option.name_th} key={index}>
                        {option.name_th}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item name="lineId" label="ไอดี ไลน์ (Line ID)">
                  <Input />
                </Form.Item>
                <Row justify="center" style={{ marginTop: 15 }}>
                  <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
                    ต่อไป
                  </ButtonEx>
                </Row>
              </Form>
            )}
            {page === '2' &&
              (heroType !== 'POSTAL' ? (
                <AddLocation
                  setPage={setPage}
                  setFormData={setFormData}
                  formData={formData}
                  heroType={heroType}
                />
              ) : (
                <AddMaterial
                  setPage={setPage}
                  formData={formData}
                  products={products}
                  heroType={heroType}
                />
              ))}
            {page === '3' && (
              <AddMaterial
                setPage={setPage}
                formData={formData}
                products={products}
                heroType={heroType}
              />
            )}
          </CardContentEx>
        </CardMaterialEx>
      ) : (
        <MainStep4 history={history} />
      )}
    </main>
  )
}

Signup.propTypes = {
  history: PropTypes.object.isRequired
}

const SignUpWithContext = withContext(Signup)
export default withSnackbar(SignUpWithContext)



// WEBPACK FOOTER //
// ./src/pages/Signup/index.js